<template>
  <div>
    <el-dialog
      class="company-bank-form-dialog"
      :visible.sync="visible"
      :fullscreen="false"
      :before-close="closeDialog">
      <template slot="title">
        {{ title }}
      </template>
      <el-form ref="form"
               :model="form"
               size="medium"
               :rules="formRules"
               label-width="120px">
        <el-form-item label="账户名称"
                      prop="company_name"
                      key="company_name">
          <el-input v-model="form.company_name"
                    clearable
                    :disabled="!!this.id"
                    placeholder="请输入账户名称">
          </el-input>
        </el-form-item>

        <el-form-item label="备注"
                      prop="remark"
                      key="remark">
          <el-input v-model="form.remark"
                    clearable
                    placeholder="请输入备注">
          </el-input>
        </el-form-item>

        <el-form-item label="银行账号"
                      prop="bank_account"
                      key="bank_account">
          <el-input v-model="form.bank_account"
                    clearable
                    :disabled="!!this.id"
                    placeholder="请输入银行账号">
          </el-input>
        </el-form-item>

        <el-form-item label="开户银行支行"
                      prop="bank"
                      key="bank">
          <el-input v-model="form.bank"
                    clearable
                    placeholder="请输入开户银行支行">
          </el-input>
        </el-form-item>

        <el-form-item label="开户银行总行"
                      prop="bank_headquarters"
                      key="bank_headquarters">
          <el-input v-model="form.bank_headquarters"
                    clearable
                    placeholder="请输入开户银行总行">
          </el-input>
        </el-form-item>
        <div style="margin:0 auto; text-align:right;">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary"
                     @click="onSubmit()">保存
          </el-button>
        </div>

      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import { formRules } from '../company-bank-account.rules.js'

export default {
  data () {
    return {
      formRules,
      form: {
        'company_name': null,
        'remark': '',
        'bank_account': null,
        'bank': null,
        'bank_headquarters': null,
      },
    }
  },
  props: {
    visible: Boolean,
    type: String,
    title: String,
    id: Number,
  },
  watch: {
    id: {
      handler (val) {
        if (val > 0) {
          this.setForm(val)
        } else {
          Object.assign(this.$data, this.$options.data.call(this))
        }
      },
    },
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.login.user,
    }),
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
    },
    closeDialogRefresh () {
      this.$emit('closeDialogRefresh')
    },
    setForm (id) {
      request.page('getCompanyBankAccountById', {id}).then(({data}) => {
        filter.setLoop(this.form, data)
      })
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.id ? this.updateCompanyBank(this.id) : this.createCompanyBank()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    createCompanyBank () {
      request.common('createCompanyBankAccount', {...this.getForm()}).then((res) => {
        this.$confirm('添加对公账户信息成功, 是否关闭弹层？', '提示', {type: 'success'}).then(() => {
          this.closeDialogRefresh()
        })
      })
    },
    updateCompanyBank (id) {
      request.common('updateCompanyBankAccount', {id, ...this.getForm()}).then((res) => {
        this.$confirm('修改对公账户信息成功, 是否关闭弹层？', '提示', {type: 'success'}).then(() => {
          this.closeDialogRefresh()
        })
      })
    },
    getForm () {
      return filter.copyJson(this.form)
    },
  }
}
</script>


<style scoped>

.company-bank-form-dialog >>> .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 600px;
  transform: translate(-50%, -50%);
  /*height:600px;*/
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}

.company-bank-form-dialog >>> .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}

</style>



// WEBPACK FOOTER //
// src/views/company-bank-account/components/CompanyBankFormDialog.vue